import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(`
    width:100%;
    margin-top: 20px;
    height: 60px;
    background-color: #F6F6F5;

    & svg {
      background-color: #F6F6F5;

    & .bar {
      fill: #E7E7E6;
      transition: opacity 0.2s ease;
    }

    & .label {
      font-size: 12px;
      font-weight: 400; // 300;
      fill: #ADADAC;
      text-anchor: start;
    }

    & .line {
      stroke: #E7E7E6;
      stroke-width: 2px;
    }

    & .brush .selection {
      fill: rgba(70, 130, 180, 0.4);
      stroke: none;
    }

    & .brush .handle {
      fill: #D8D8D6;
      cursor: ew-resize;
    }

    & .brush .handle--w,
    & .brush .handle--e {
      width: 12px;
      height: 24px;
      rx: 0;
      ry: 0;
      y: 0;
    }
    }
`)
